import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

const iconSlider = new Swiper(".slider--icon", {
    modules: [Navigation, Pagination],
    slidesPerView: 2,
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },

    breakpoints: {
        "0": {
          slidesPerView: 2,
        },
        "767": {
          slidesPerView: 4,
        }
    },
});

const logoSlider = new Swiper(".slider--logo", {
  modules: [Navigation, Pagination],
  slidesPerView: 2,
  pagination: {
      el: '.swiper-pagination',
  },
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },

  breakpoints: {
      "0": {
        slidesPerView: 2,
      },
      "767": {
        slidesPerView: 4,
      }
  },
});

const teamSlider = new Swiper(".slider--team", {
  modules: [Navigation, Pagination],
  slidesPerView: 1.5,
  pagination: {
      el: '.swiper-pagination',
  },
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },

  breakpoints: {
      "0": {
        slidesPerView: 1.5,
      },
      "767": {
        slidesPerView: 3,
      }
  },
});
